import React, {useState} from 'react';
import cl from "./DatesBlock.module.css";
import {Button, Paper, Tooltip} from "@mui/material";
import {settings} from "../../AppVars";

const DatesBlock = ({dates}) => {

    const [updCount, setUpdCount] = useState(0)

    return (
        <Paper variant="outlined" sx={{
            backgroundColor: "#e0e0e8",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "15px"
        }}>
            <div className={cl.header}>
                <span className={cl.title}>Даты</span>
                {dates.length === 0 && <span className={cl.emptyListLabel}>(нет)</span>}
                {settings.useShortDatesInfo && renderShortInfo()}
                {dates.length > 0 && <span className={cl.total}>(всего: {dates.length})</span>}
                {renderToggleButton()}
            </div>
            {!settings.useShortDatesInfo && dates.length > 0 && <div className={cl.fullList}>
                {dates.map((date, index) => renderDateTime(date, index))}
            </div>}
        </Paper>
    );

    function renderToggleButton() {
        return <Tooltip
            title={settings.useShortDatesInfo ? "Переключиться в подробный режим" : "Переключиться в компактный режим"}>
            <Button
                variant="outlined"
                size="small"
                sx={{marginLeft: "auto"}}
                onClick={onToggleBtnClick}
            >
                {settings.useShortDatesInfo ? "▼" : "▲"}
            </Button>
        </Tooltip>
    }

    function onToggleBtnClick() {
        settings.useShortDatesInfo = !settings.useShortDatesInfo;
        setUpdCount(updCount > 1000000 ? 0 : updCount + 1);
    }

    function renderShortInfo() {
        if (dates.length === 0)
            return null;

        if (dates.length === 1)
            return renderDateTime(dates[0], 0);

        if (dates.length === 2)
            return <>
                {renderDateTime(dates[0], 0)}
                {renderDateTime(dates[1], 1)}
            </>;

        return <>
            {renderDateTime(dates[0], 0)}
            <span className={cl.date}>...</span>
            {renderDateTime(dates[dates.length - 1], 1)}
        </>
    }

    function renderDateTime(date, key = undefined) {
        const dt = new Date(date);
        return <span className={cl.dateTime} key={key}>
            <span className={cl.date}>{extractDate(date)}</span>
            <span className={cl.time}>{extractTime(date)}</span>
        </span>
    }
};

function extractDate(date) {
    // 2026-10-15T19:00:00+03:00
    return `${date.slice(8, 10)}.${date.slice(5, 7)}.${date.slice(0, 4)}`;
}

function extractTime(date) {
    // 2026-10-15T19:00:00+03:00
    return date.slice(11, 16);
}

export default DatesBlock;